import { useTranslation } from "react-i18next";
import { BookableSlot, BookableSlotDay } from "../../features/bookable-slots/models/BookableSlots";
import { formatSeatDate } from "../../features/sessions/utils/seatDateTime";
import { formatTimeOfDay } from "../../features/utils/displayFormat";

interface SlotDayListProps {
  days: BookableSlotDay[];
  selectedKey: string | null;
  onSelect: (slot: BookableSlot) => void;
  disabled?: boolean;
}

/**
 * Free slots grouped by day as tappable time chips. Dates and times are the instructor's
 * own wall clock (the wire values are local to their zone), never the viewer's.
 */
const SlotDayList = ({ days, selectedKey, onSelect, disabled = false }: SlotDayListProps) => {
  const { i18n } = useTranslation();

  return (
    <ul className="flex flex-col gap-3">
      {days.map((day) => (
        <li key={day.date}>
          <p className="mb-1 text-sm font-medium text-grey-20 dark:text-white">
            {formatSeatDate(day.date, i18n.language)}
          </p>
          <div className="flex flex-wrap gap-2">
            {day.slots.map((slot) => {
              const selected = slot.key === selectedKey;
              return (
                <button
                  key={slot.key}
                  type="button"
                  aria-pressed={selected}
                  disabled={disabled}
                  onClick={() => onSelect(slot)}
                  className={
                    selected
                      ? "rounded-full border border-primary-40 bg-primary-40 px-3 py-1 text-sm font-medium text-white dark:border-primary-90 dark:bg-primary-90 dark:text-primary-10"
                      : "rounded-full border border-grey-80 bg-white px-3 py-1 text-sm text-grey-20 hover:bg-grey-95 dark:border-primary-30 dark:bg-primary-10 dark:text-white dark:hover:bg-primary-20"
                  }
                >
                  {formatTimeOfDay(slot.timeLocal, i18n.language)}
                </button>
              );
            })}
          </div>
        </li>
      ))}
    </ul>
  );
};

export default SlotDayList;
